import { render, staticRenderFns } from "./Territories.vue?vue&type=template&id=45935512&"
import script from "./Territories.vue?vue&type=script&lang=js&"
export * from "./Territories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports